const toSnakeCase = (input: string): string => input.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();

export default toSnakeCase;
